import { forwardRef } from 'react'
import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
import { Loader } from '@calendly/ui/components/loader'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _LoaderContainer from "schedule_submit_button-LoaderContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/schedule_submit_button.js?styleId=LoaderContainer";
import _TextSpan from "schedule_submit_button-TextSpan.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/schedule_submit_button.js?styleId=TextSpan";
import _StyledBareButton from "schedule_submit_button-StyledBareButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/enter_details/booking_form/schedule_submit_button.js?styleId=StyledBareButton";

const spaceLarge = 'var(--spacing-1x, 1rem)'
const spaceSmall = 'var(--spacing-0-5x, 0.5rem)'
const borderRadiusButton = 'var(--border-radius-button, var(--border-radius-pill))'
const colorStrokeDisabled = 'var(--colorStrokeDisabled, var(--coreColorNeutral300))'
const colorSurfaceDisabled = 'var(--colorSurfaceDisabled, var(--coreColorNeutral300))'
const colorTextDisabled = 'var(--colorTextDisabled, var(--coreColorNeutral500))'
const fontSizeLabelLarge = 'var(--fontSizeLabelLarge, 0.875rem)'
const fontWeightSemibold = 'var(--fontWeightSemibold, 600)'
const lineHeightLabelLarge = 'var(--lineHeightLabelLarge, 1.25rem)'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const primaryColorDarker10 = 'var(--primary-color-darker-10, rgba(0, 95, 230, 1))'
const primaryColorDarker30 = 'var(--primary-color-darker-30, rgba(0, 74, 179, 1))'
const primaryTextColor = 'var(--primary-text-color, #ffffff)'

const LoaderContainer = /*#__PURE__*/styled('span', null, {
  displayName: "LoaderContainer",
  styles: _LoaderContainer
})

const TextSpan = /*#__PURE__*/styled('span', null, {
  displayName: "TextSpan",
  styles: _TextSpan
})

const StyledBareButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "StyledBareButton",
  styles: _StyledBareButton,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

/** Primary submit control using embed --primary-color (BareButton avoids @calendly/ui Button decoration overrides). */
export const ScheduleSubmitButton = forwardRef(({
  loading = false,
  disabled,
  children,
  onClick,
  type = 'button',
  size: _size,
  ...rest
}, ref) => {
  const handleClick = (event) => {
    if (loading) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    onClick?.(event)
  }

  return (
    <StyledBareButton
      ref={ref}
      type={type}
      loading={loading}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      onClick={handleClick}
      {...rest}
    >
      <TextSpan loading={loading}>{children}</TextSpan>
      {loading && (
        <LoaderContainer>
          <Loader inheritColor size="small" />
        </LoaderContainer>
      )}
    </StyledBareButton>
  )
})
